import React from 'react';

import {Sequence} from 'components/Sequence';
import {Cutsite as CutsiteType} from 'constants/MolbioConstants';
import Cutsite from 'molbio/enzymes/backbone/CutSite';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';

import {Assembly, AssemblySlotType} from './AssemblyModels';
import CurrentFragmentInfo from './CurrentFragmentInfo';
// @ts-expect-error
import FinalizeComponents from './FinalizeComponents';
import AssemblyErrorsWarnings from './views/AssemblyErrorsWarnings';

interface Props {
  assembly: Assembly;
  activeSlot: AssemblySlotType;
  cutsites: Array<CutsiteType>;
  selection: {
    start: number;
    end: number;
    cutStart: Cutsite;
    cutEnd: Cutsite;
  };
  sequence: Sequence;
  updateParameters: () => void;
  createAssembly: () => void;
  deleteAssembly: () => void;
  errors: Array<string>;
  warnings: Array<string>;
}

interface State {
  showParameters: boolean;
}

class ActionZone extends React.Component<Props, State> {
  override state: State = {
    showParameters: false,
  };

  toggleParameters = (): void => {
    this.setState({showParameters: !this.state.showParameters});
  };

  override render(): JSX.Element {
    return (
      <Row>
        <Col sm={5} className="js-fragment-info-wrapper u-small-spacing-bottom">
          {this.props.activeSlot != null ? (
            <CurrentFragmentInfo
              activeSlot={this.props.activeSlot}
              assembly={this.props.assembly}
              cutsites={this.props.cutsites}
              enzyme={this.props.assembly.enzyme()}
              selection={this.props.selection}
              sequence={this.props.sequence}
              toggleParameters={this.toggleParameters}
            />
          ) : (
            <div>
              <h4>Set Fragment</h4>
              <div className="faded u-small-spacing-top">Select an assembly fragment below.</div>
            </div>
          )}
        </Col>
        <Col sm={7} className="assembly-settings-col">
          <div className="pull-right">
            {FinalizeComponents.for(this.props.assembly, {
              updateParameters: this.props.updateParameters,
              createAssembly: this.props.createAssembly,
              deleteAssembly: this.props.deleteAssembly,
              showParameters: this.state.showParameters,
              toggleParameters: this.toggleParameters,
            })}
          </div>
          <AssemblyErrorsWarnings
            title="Overall Assembly"
            errors={this.props.errors}
            warnings={this.props.warnings}
            method={this.props.assembly.method()!}
          />
        </Col>
      </Row>
    );
  }
}

export default ActionZone;
